// extracted by mini-css-extract-plugin
export default {"dayorder_container":"Dayorder_dayorder_container__tQRuu"};